angular.module('inspinia').directive('baseIcon', () => {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      size: '@',
      cursor: '@',
    },
    templateUrl: `/manage/src/view/directive/base_icon.html?${new Date().getTime()}`,
    link($scope) {
      /**
       * Iconのサイズを返す
       * @returns {string} smallまたはlargeのいずれか
       */
      $scope.baseIconSize = () => {
        return $scope.size !== 'small' && $scope.size !== 'large' ? 'small' : $scope.size;
      };

      /**
       * CSSのクラス名を返す
       * @returns {string} anglrC-icon
       */
      $scope.baseIconClasses = () => {
        let iconSize = 'r';
        const size = $scope.baseIconSize();
        if (size === 'large') {
          iconSize = 'l';
        } else {
          iconSize = 'r';
        }
        let classes = `anglrC-icon anglrC-icon--${iconSize}`;

        if ($scope.cursor) {
          classes = classes + ' anglrC-icon-cursor';
        }

        return classes;
      };

      $scope.showAdd = () => $scope.name === 'add';
      $scope.showAddOutline = () => $scope.name === 'add-outline';
      $scope.showAlertCircle = () => $scope.name === 'alert-circle';
      $scope.showArrowDownOutline = () => $scope.name === 'arrow-down-outline';
      $scope.showArrowForwardOutline = () => $scope.name === 'arrow-forward-outline';
      $scope.showArrowUndo = () => $scope.name === 'arrow-undo';
      $scope.showBookOutline = () => $scope.name === 'book-outline';
      $scope.showBulbOutline = () => $scope.name === 'bulb-outline';
      $scope.showCalculaterOutline = () => $scope.name === 'calculater-outline';
      $scope.showCaretDown = () => $scope.name === 'caret-down';
      $scope.showCheckbox = () => $scope.name === 'checkbox';
      $scope.showCheckmarkCircle = () => $scope.name === 'checkmark-circle';
      $scope.showCheckmarkCircleOutline = () => $scope.name === 'checkmark-circle-outline';
      $scope.showCheckmarkOutline = () => $scope.name === 'checkmark-outline';
      $scope.showChevronBackOutline = () => $scope.name === 'chevron-back-outline';
      $scope.showChevronDown = () => $scope.name === 'chevron-down';
      $scope.showChevronDownOutline = () => $scope.name === 'chevron-down-outline';
      $scope.showChevronForward = () => $scope.name === 'chevron-forward';
      $scope.showChevronForwardOutline = () => $scope.name === 'chevron-forward-outline';
      $scope.showChevronUp = () => $scope.name === 'chevron-up';
      $scope.showChevronUpOutline = () => $scope.name === 'chevron-up-outline';
      $scope.showClose = () => $scope.name === 'close';
      $scope.showCloseCircleOutline = () => $scope.name === 'close-circle-outline';
      $scope.showCloseOutline = () => $scope.name === 'close-outline';
      $scope.showCloudUploadOutline = () => $scope.name === 'cloud-upload-outline';
      $scope.showDocumentOutline = () => $scope.name === 'document-outline';
      $scope.showDocumentTextOutline = () => $scope.name === 'document-text-outline';
      $scope.showDownloadOutline = () => $scope.name === 'download-outline';
      $scope.showDuplicateOutline = () => $scope.name === 'duplicate-outline';
      $scope.showFacility = () => $scope.name === 'facility';
      $scope.showFileTrayOutline = () => $scope.name === 'file-tray-outline';
      $scope.showHelpCircle = () => $scope.name === 'help-circle';
      $scope.showHelpCircleOutline = () => $scope.name === 'help-circle-outline';
      $scope.showImageOutline = () => $scope.name === 'image-outline';
      $scope.showInformationCircle = () => $scope.name === 'information-circle';
      $scope.showLogOutOutline = () => $scope.name === 'log-out-outline';
      $scope.showMailOutline = () => $scope.name === 'mail-outline';
      $scope.showOpenOutline = () => $scope.name === 'open-outline';
      $scope.showPencil = () => $scope.name === 'pencil';
      $scope.showPencilOutline = () => $scope.name === 'pencil-outline';
      $scope.showPeople = () => $scope.name === 'people';
      $scope.showPerson = () => $scope.name === 'person';
      $scope.showPersonCircleOutline = () => $scope.name === 'person-circle-outline';
      $scope.showPrint = () => $scope.name === 'print';
      $scope.showPrintOutline = () => $scope.name === 'print-outline';
      $scope.showPushOutline = () => $scope.name === 'push-outline';
      $scope.showRefreshOutline = () => $scope.name === 'refresh-outline';
      $scope.showRocketOutline = () => $scope.name === 'rocket-outline';
      $scope.showSave = () => $scope.name === 'save';
      $scope.showSearch = () => $scope.name === 'search';
      $scope.showSeedling = () => $scope.name === 'seedling';
      $scope.showSwapHorizontalOutline = () => $scope.name === 'swap-horizontal-outline';
      $scope.showSwapVerticalOutline = () => $scope.name === 'swap-vertical-outline';
      $scope.showSyncOutline = () => $scope.name === 'sync-outline';
      $scope.showTrash = () => $scope.name === 'trash';
      $scope.showTrashOutline = () => $scope.name === 'trash-outline';
      $scope.showTroubledFace = () => $scope.name === 'troubled-face';
      $scope.showVideocam = () => $scope.name === 'videocam';
      $scope.showWarning = () => $scope.name === 'warning';
      $scope.showWarningOutline = () => $scope.name === 'warning-outline';
    },
  };
});
